import React from "react";
import { flowerIcon, daffodillogo } from "../Images";
import "./feedback.css";

class Container extends React.Component {
  render() {
    const { children, headtext, isMobile, logo, subtext, data = {} } = this.props;
    const mainLogo = logo || daffodillogo;
    return (
      <div className={isMobile ? "containerSM" : "containerMD"}>
        <div>
          <img src={flowerIcon} alt="Logo" className="flowerIcon"></img>
          <img src={mainLogo} alt="Logo" className="daffodilLogo"></img>
        </div>
        {headtext ? (
          <div className={isMobile ? "containerSM" : "containerMD"}>
            <h1 className={isMobile ? "mainHeaderSM" : "mainHeaderMD"}> {headtext} </h1>
            <p className={isMobile ? "subHeaderSM" : "subHeaderMD"}> {subtext} </p>
            {/* <div className={isMobile ? "yellowBorderSM" : "yellowBorderMD"}></div> */}
          </div>
        ) : null}
        <div className={isMobile ? "innerBoxSM" : "innerBoxMD"}>
          {typeof children === "function" ? children() : children}
        </div>
      </div>
    );
  }
}

export default Container;
